module.exports = __webpack_public_path__ + "media/images/FortWaynes-2c6838f6116895c8c0d47e0f82557f71.png";